import { convertBytesToMB } from '@/lib/utils';
import Image from 'next/image';

const DownloadElem = ({
  name,
  file,
  size,
  fileType,
}: {
  name: string;
  file: string;
  size: string;
  fileType: string;
}) => {
  const downloadURL = `${process.env.NEXT_PUBLIC_BASE_URL}/assets/${file}`;

  const getIconByFileType = (type?: string) => {
    if (!type) return '/icons/file.svg';

    if (type.includes('pdf')) return '/icons/pdf.svg';
    if (type.includes('csv')) return '/icons/csv.svg';

    if (type.includes('word') || type.includes('document'))
      return '/icons/word.svg';

    if (type.includes('excel') || type.includes('spreadsheet'))
      return '/icons/excel.svg';

    if (type.startsWith('image/')) return '/icons/img.svg';

    if (type.includes('zip')) return '/icons/zip.svg';

    if (type.startsWith('text/')) return '/icons/text.svg';

    return '/icons/file.svg';
  };

  return (
    <a
      href={downloadURL}
      target="_blank"
      rel="noopener noreferer"
      className={`group flex items-center gap-6 cursor-pointer p-4 rounded-xl border border-border-gray font-proxima_font`}
    >
      <Image
        src={getIconByFileType(fileType)}
        alt={`${fileType} icon`}
        width={40}
        height={40}
        className="size-10"
      />
      <div className="flex flex-col justify-between h-full">
        <h4 className="font-semibold group-hover:underline underline-offset-4 text-base mb-1">
          {name}
        </h4>
        {size && (
          <p className="text-sm text-off-black">
            {convertBytesToMB(Number(size))} MB
          </p>
        )}
      </div>
    </a>
  );
};

export default DownloadElem;
